var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-tab',{attrs:{"title":"活动亮点"}},[_c('img',{staticClass:"one-img",attrs:{"src":require("../../../../assets/images/home/highlights_02.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }